import { useState } from "react";

// Data
import { GOOGLE_FONTS } from "./data/constants";
import { T } from "./data/translations";

// Utils
import { getLangFont } from "./utils/helpers";

// Shared UI components
import { Navbar, Footer, WhatsAppFAB } from "./components/SharedUI";

// Pages
import HomePage     from "./pages/HomePage";
import RatesPage    from "./pages/RatesPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage    from "./pages/AdminPage";

/**
 * App – root component.
 * Manages global lang + page state and wires together the
 * Navbar, page content, WhatsApp FAB, and Footer.
 */
export default function App() {
  const [lang, setLang] = useState("hi");
  const [page, setPage] = useState("home");

  const t     = T[lang];
  const isRTL = lang === "ur";

  return (
    <>
      {/* Global styles */}
      <style>{`
        ${GOOGLE_FONTS}
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { background: #faf7f0; }
        @keyframes spin    { from { transform: rotate(0deg)  } to { transform: rotate(360deg) } }
        @keyframes fadeIn  { from { opacity: 0; transform: translateY(8px) } to { opacity: 1; transform: translateY(0) } }
        ::-webkit-scrollbar       { width: 5px; }
        ::-webkit-scrollbar-thumb { background: #c5d8c9; border-radius: 3px; }
      `}</style>

      {/* Sticky navigation */}
      <Navbar
        lang={lang}
        setLang={setLang}
        page={page}
        setPage={setPage}
        t={t}
      />

      {/* Page content */}
      <div
        style={{
          animation:  "fadeIn 0.3s ease",
          minHeight:  "calc(100vh - 56px)",
          direction:  isRTL ? "rtl" : "ltr",
        }}
      >
        {page === "home"     && <HomePage     lang={lang} t={t} onNav={setPage} />}
        {page === "rates"    && <RatesPage    lang={lang} t={t} />}
        {page === "register" && <RegisterPage lang={lang} t={t} />}
        {page === "admin"    && <AdminPage />}
      </div>

      {/* Floating WhatsApp CTA — hidden on the register page itself */}
      {/*page !== "register" && (
        <WhatsAppFAB
          lang={lang}
          isRTL={isRTL}
          t={t}
          onClick={() => setPage("register")}
        />
      )*/}

      {/* Footer */}
      <Footer lang={lang} setLang={setLang} t={t} />
    </>
  );
}
